import {
  Box,
  Button,
  Card,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import FormControl from "@mui/material/FormControl";
import { useDispatch, useSelector } from "react-redux";
import masterActions from "../../redux/master/actions";
import customerActions from "../../redux/customer/actions";
import VBSATable from "../../common/VBSATable";

export default function Index() {
  const dispatch = useDispatch();
  const [courseid, setCourseId] = useState(0);
  const [buttonClick, setButtonClick] = useState(false);
  const [courseError, setCourseError] = useState("");
  const [preference, setPreference] = useState(1);
  const [preferenceError, setPreferenceError] = useState("");
  const preferencesno = [
    { name: "Preference 1", value: 1 },
    { name: "Preference 2", value: 2 },
    { name: "Preference 3", value: 3 },
    { name: "Preference 4", value: 4 },
  ];

  const { courseList } = useSelector((state) => state.masterReducer);

  const { vbsaReport } = useSelector((state) => state.customerReducer);

  useEffect(() => {
    setCourseId(0);
    setPreference(1);
    localStorage.removeItem("vbsaReport");
  }, []);

  useEffect(() => {
    dispatch({ type: masterActions.GET_COURSE_LIST });
    const storedData = JSON.parse(localStorage.getItem("vbsaReport"));
    if (storedData) {
      setCourseId(storedData.courseid);
    }
    dispatch({
      type: customerActions.GET_VBSA_REPORT,
      payload: {
        courseid: 0,
        preference: 0,
      },
    });

    return () => {};
  }, [dispatch]);

  const onChangeCourse = (e) => {
    setCourseId(e.target.value);
  };

  const onChangePreference = (event) => {
    setPreference(event.target.value);
    setPreference(event.target.value);
  };

  const handleGenerate = () => {
    setButtonClick(true);
    let hasError = false;

    if (courseid === 0) {
      setCourseError("Course is required");
      hasError = true;
    } else {
      setCourseError("");
    }

    if (!hasError) {
      const formData = {
        courseid: courseid,
        preference: preference,
      };
      localStorage.setItem("vbsaReport", JSON.stringify(formData));

      dispatch({
        type: customerActions.GET_VBSA_REPORT,
        payload: {
          courseid: courseid,
          preference: preference,
        },
      });
    }
  };

  useEffect(() => {
    const removeLocalStorage = () => {
      localStorage.removeItem("vbsaReport");
    };

    window.addEventListener("beforeunload", removeLocalStorage);

    return () => {
      window.removeEventListener("beforeunload", removeLocalStorage);
    };
  }, []);

  const applicationStatusColumns = [
    {
      name: "Course Name",
      dataIndex: "coursename",
    },
    {
      name: "Preference",
      dataIndex: "preference",
    },
    {
      name: "State",
      dataIndex: "state",
    },
    {
      name: "District",
      dataIndex: "district",
    },
    {
      name: "No. of Attempts",
      dataIndex: "number_of_attempts_count",
    },
    {
      name: "Candidate Count",
      dataIndex: "candidate_count",
    },
  ];

  const applicationStatusData = Array.isArray(vbsaReport)
    ? vbsaReport.map((entry) => ({
        coursename: entry.coursename ?? "NA",
        preference: entry.preference ?? "NA",
        state: entry.state ?? "NA",
        district: entry.district ?? "NA",
        number_of_attempts_count: Number(entry.number_of_attempts_count ?? 0),
        candidate_count: Number(entry.candidate_count ?? 0),
      }))
    : [];

  const safeTableData = courseid === 0 ? [] : applicationStatusData;

  const buildCsvHeaders = () => {
    return applicationStatusColumns.map((col) => col.name).join(",");
  };

  const buildCsvRows = () =>
    applicationStatusData.map((row) =>
      applicationStatusColumns.map((col) => row[col.dataIndex] ?? "").join(",")
    );

  const buildTotalRow = () => {
    const totalCandidates = applicationStatusData.reduce(
      (sum, r) => sum + Number(r.candidate_count || 0),
      0
    );

    return ["TOTAL", "", "", "", "", totalCandidates].join(",");
  };

  const downloadPreferenceWiseReport = () => {
    if (!applicationStatusData.length) {
      alert("No data available to export");
      return;
    }

    const headers = buildCsvHeaders();
    const rows = buildCsvRows();
    const totalRow = buildTotalRow();

    const csvContent = [headers, ...rows, totalRow].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
    const courseName =
      courseid === -1
        ? "All_Courses"
        : courseList?.all?.find((c) => c.courseid === courseid)?.coursename ||
          "Course";
    const preferenceText = `Preference_${preference}`;

    link.href = url;
    link.setAttribute(
      "download",
      `VBSA_Report_${courseName}_${preferenceText}_${timestamp}.csv`
    );

    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  return (
    <>
      <Box
        sx={{
          margin: "1rem auto",
          backgroundColor: "rgba(255, 255, 255, 1)",
          borderRadius: "8px",
          padding: "10px",
        }}
      >
        <Card sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography>VBSA Report</Typography>
          </Box>
          <Grid item sm={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              sx={{ gap: 2, flexWrap: "wrap", mt: 2, alignItems: "center" }}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                sx={{ gap: 2, flexWrap: "wrap", mt: 2 }}
              >
                <FormControl error={!!courseError} sx={{ width: "220px" }}>
                  <Select
                    size="small"
                    onChange={onChangeCourse}
                    value={courseid}
                    defaultValue={0}
                    sx={{ height: "56px" }}
                  >
                    <MenuItem value={0} selected>
                      Select Course <span style={{ color: "red" }}>*</span>
                    </MenuItem>
                    <MenuItem value={-1}>All</MenuItem>
                    {courseList?.all
                      ?.filter((course) => course.isactive === "1")
                      .map((course, i) => (
                        <MenuItem key={i} value={course.courseid}>
                          {course.coursename}
                        </MenuItem>
                      ))}
                  </Select>
                  {courseError && (
                    <Typography variant="caption" color="error">
                      {courseError}
                    </Typography>
                  )}
                </FormControl>

                {/* select preference  */}
                <FormControl sx={{ width: "220px", marginLeft: 2 }}>
                  <Select
                    size="small"
                    value={preference}
                    onChange={onChangePreference}
                    sx={{ height: "56px" }}
                  >
                    <MenuItem value="" disabled>
                      Select Preference
                    </MenuItem>
                    {preferencesno.map((pref) => (
                      <MenuItem key={pref.value} value={pref.value}>
                        {pref.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box sx={{ marginTop: 1, display: "flex", gap: 2 }}>
                <BluePrimaryButton
                  title={"Generate"}
                  handleSubmit={handleGenerate}
                />
                <Button
                  variant="contained"
                  color="success"
                  onClick={downloadPreferenceWiseReport}
                  sx={{ height: "40px" }}
                >
                  Export To CSV
                </Button>
              </Box>
            </Box>
          </Grid>

          <Box sx={{ marginTop: 1 }}>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: "500",
                color: "black",
                fontSize: "20px",
                lineHeight: "24px",
                mb: 2,
                backgroundColor: "whitesmoke",
                padding: "8px",
                borderRadius: "4px",
              }}
            >
              VBSA Report{" "}
            </Typography>
          </Box>
          <VBSATable
            columnData={applicationStatusColumns}
            tableData={safeTableData}
          />
        </Card>
      </Box>
    </>
  );
}
